import React from 'react';
import './dispatch-info-details.scss';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import TextField from '@mui/material/TextField';
import { SVGS } from '../../../assets';
import { InputWrapper } from '../input-wrapper';
import { commonInputSx } from '../../../helper';

export const dispatch_Vehicle_Details = [
  {
    key: 'dispatchDocNo',
    label: 'AWB / LR/ Docket Number',
    placeholder: 'AWB / LR / Docket Number',
    required: true,
    type: 'text',
  },
  {
    key: 'dispatchDate',
    label: 'Select the Dispatch Date',
    placeholder: 'Select Date',
    required: true,
    type: 'date',
  },
];

interface DispatchInfoDetailsProps {
  formData: Record<string, string | string[]>;
  onChange: (key: string, value: string) => void;
}

export const DispatchInfoDetails: React.FC<DispatchInfoDetailsProps> = ({
  formData,
  onChange,
}) => {
  return (
    <div className="dispatch-details">
      {dispatch_Vehicle_Details.map((field, index) => {
        const label = `${field.label}${field.required ? '*' : ''}`;

        switch (field.type) {
          case 'date': {
            const rawValue = formData[field.key];

            const parsedValue =
              typeof rawValue === 'string' && rawValue ? dayjs(rawValue) : null;
            return (
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                key={`${field.key}-${index}`}
              >
                <DatePicker
                  label={label}
                  format="DD/MM/YYYY"
                  value={parsedValue}
                  onChange={(newValue) =>
                    onChange(
                      field.key,
                      newValue ? newValue.toISOString() : '' // store ISO (recommended)
                    )
                  }
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      margin: 'normal',
                      variant: 'outlined',
                      sx: commonInputSx,
                      InputLabelProps: { shrink: true },
                      inputProps: {
                        placeholder: field.placeholder,
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            );
          }
          default:
            return (
              <TextField
                key={`${field.key}-${index}`}
                label={label}
                value={(formData[field.key] as string) ?? ''}
                onChange={(e) => onChange(field.key, e.target.value)}
                fullWidth
                margin="normal"
                variant="outlined"
                sx={commonInputSx}
                InputLabelProps={{ shrink: true }}
                placeholder={field.placeholder}
              />
            );
        }
      })}

      <div className="dispatch-details--secondary-view">
        <span className="dispatch-details--title font-medium">
          {
            'Please enter the number of boxes you are sending or the total weight of the package.'
          }
        </span>

        <div className="dispatch-details--bottom-view">
          <InputWrapper
            icon={SVGS.Assets}
            placeholder={'Total Box'}
            value={(formData['totalBox'] as string) ?? ''}
            onChange={(value) => onChange('totalBox', value)}
          />
          <span className="dispatch-details--bottom-text font-medium">
            {'OR'}
          </span>
          <InputWrapper
            icon={SVGS.Weight}
            placeholder={'Total Weight'}
            value={(formData['totalWeight'] as string) ?? ''}
            onChange={(value) => onChange('totalWeight', value)}
          />
        </div>
      </div>
    </div>
  );
};
